import { Container, FieldInput } from './styles';

const Input = ({ ...props }) => {
  return (
    <Container>
      <FieldInput {...props} />
    </Container>
  );
};

export default Input;
